/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.32/esri/copyright.txt for details.
*/
import{WGLDrawPhase as s}from"../../enums.js";class t{constructor(){this.drawPhase=s.MAP|s.HITTEST|s.HIGHLIGHT|s.DEBUG}startup(){}shutdown(s){}}export{t as Technique};
